import { useState, useEffect } from 'react'

import donut from '../../images/donut.mp4'
import SECTIONS from '../../const/sections'
import WorkingInSpace from '../../components/content/workingInSpace/WorkingInSpace'
import Health from '../../components/content/health/Health'
import Food from '../../components/content/food/Food'
import AllAround from '../../components/content/all around/AllAround'
import Pension from '../../components/content/pension/Pension'
import Search from '../content/search/Search'
import {
  workingInSpace1,
  workingInSpace2,
  workingInSpace3,
  health1,
  food1,
  allAround1,
  pension1,
} from '../../const/contentData'
import openingParagraph from '../../const/openingParagraph'
import arrowUp from '../../images/arrowUp.png'
import classes from './homePage.module.css'

function HomePage({ onNavigate, handleScrollToSection }) {
  const [searchFixed, setSearchFixed] = useState(false)
  const [searchResults, setSearchResults] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  const toggleObservedModels = (model) => {
    onNavigate(model)
  }

  useEffect(() => {
    const handleScroll = () => {
      const card4 = document.getElementById('card4')

      if (card4) {
        const card4Rect = card4.getBoundingClientRect()

        if (card4Rect.y * -1 > card4Rect.height - 160) {
          setSearchFixed(true)
        } else {
          setSearchFixed(false)
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const allContentData = {
    health: health1,
    workingInSpace: workingInSpace1
      .concat(workingInSpace2)
      .concat(workingInSpace3),
    food: food1,
    allAround: allAround1,
    pension: pension1,
  }

  const handleSearch = () => {
    const query = searchTerm.trim()
    if (!query) return
    const results = []

    Object.entries(openingParagraph).forEach(([component, texts]) => {
      texts.forEach((text) => {
        if (text.toLowerCase().includes(query.toLowerCase())) {
          const resultExists = results.some(
            (r) => r.component === component && r.accordionId === null
          )
          if (!resultExists) {
            results.push({ component, accordionId: null, accordionName: null })
          }
        }
      })
    })

    Object.entries(allContentData).forEach(([component, items]) => {
      items.forEach(({ id, title, content, uniqueId }) => {
        if (
          title.toLowerCase().includes(query.toLowerCase()) ||
          content.toLowerCase().includes(query.toLowerCase())
        ) {
          const resultExists = results.some(
            (r) => r.component === component && r.accordionId === id
          )
          if (!resultExists) {
            results.push({
              component,
              accordionId: id,
              uniqueId,
              accordionName: title,
            })
          }
        }
      })
    })

    const numOfResults = 10
    const limitedResults = results.slice(0, numOfResults)

    setSearchResults(limitedResults)
  }

  return (
    <>
      <div className={classes.main_container} id="homePage">
        <div
          onClick={() => toggleObservedModels(SECTIONS.PENSION)}
          className={`${classes.card_1} ${classes.card} pointer`}
        >
          <div className={classes.img_content} dir="rtl">
            <div>
              <h2>פנסיה, ביטוח</h2>
              <h2>והטבות ששווה להכיר</h2>
            </div>
            <img src={arrowUp} alt="arrowUp" />
          </div>
        </div>
        <div
          onClick={() => toggleObservedModels(SECTIONS.HEALTH)}
          className={`${classes.card_2} ${classes.card} pointer`}
        >
          <div className={classes.img_content} dir="rtl">
            <div>
              <h2>זה יופי</h2>
              <h2>להיות בריא</h2>
            </div>
            <img src={arrowUp} alt="arrowUp" />
          </div>
        </div>
        <div
          onClick={() => toggleObservedModels(SECTIONS.WORKING_IN_SPACE)}
          className={`${classes.card_3} ${classes.card} pointer`}
        >
          <div className={classes.img_content} dir="rtl">
            <div>
              <h2>עובדים</h2>
              <h2>בחלל</h2>
            </div>
            <img src={arrowUp} alt="arrowUp" />
          </div>
        </div>
        <div id="card4" className={`${classes.card_4} ${classes.card}`}>
          <Search
            searchFixed={searchFixed}
            handleScrollToSection={handleScrollToSection}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            searchResults={searchResults}
            handleSearch={handleSearch}
            setSearchResults={setSearchResults}
          />
        </div>
        <div
          onClick={() => toggleObservedModels(SECTIONS.ALL_AROUND)}
          className={`${classes.card_5} ${classes.card} pointer`}
        >
          <div className={classes.img_content} dir="rtl">
            <div>
              <h2>NICE</h2>
              <h2>Everyday</h2>
            </div>
            <img src={arrowUp} alt="arrowUp" />
          </div>
        </div>

        <div
          onClick={() => toggleObservedModels(SECTIONS.FOOD)}
          className={`${classes.card_6} ${classes.card} pointer`}
        >
          <video className={classes.video} autoPlay muted loop>
            <source src={donut} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className={classes.img_content} dir="rtl">
            <div>
              <h2>אוכלים שותים</h2>
              <h2>ואוהבים את זה!</h2>
            </div>
            <img src={arrowUp} alt="arrowUp" />
          </div>
        </div>
      </div>

      <Health id="health" searchTerm={searchTerm} />
      <Pension id="pension" searchTerm={searchTerm} />
      <AllAround id="allAround" searchTerm={searchTerm} />
      <Food id="food" searchTerm={searchTerm} />
      <WorkingInSpace
        id="workingInSpace"
        searchTerm={searchTerm}
        handleScrollToSection={handleScrollToSection}
      />
    </>
  )
}

export default HomePage
